import axios from '../config/axios';

const GET_QST_LIST = 'api/Question/listQuestions';
const GET_QRT_LIST = 'api/Questionnaire/listQuestionnaires';
const GET_TIR_LIST = 'api/Questionnaire/listTir';
const POST_QST = 'api/Question/ajouterQuestion';
const POST_QST_ORDER = 'api/Question/modifierOrdreQuestions';
const POST_QRT = 'api/Questionnaire/ajouterQuestionnaire';
const DELETE_QST = 'api/Question/supprimerQuestion';
const DELETE_QRT = 'api/Questionnaire/supprimerQuestionnaire';
const UPDATE_QST = 'api/Question/modifierQuestion';
const UPDATE_QRT = 'api/Questionnaire/modifierQuestionnaire';


export const getQstList = () => {
    return axios.get(GET_QST_LIST);
};

export const getTirList = () => {
    return axios.get(GET_TIR_LIST);
};

export const getQrtList = () => {
    return axios.get(GET_QRT_LIST);
};

export const postQst = (data) => {
    return axios.post(POST_QST, data);
};

export const postQstOrder = (data) => {
    return axios.post(POST_QST_ORDER, data);
};

export const postQrt = (data) => {
    return axios.post(POST_QRT, data);
};

export const deleteQst = (id) => {
    return axios.delete(DELETE_QST, {
        params: {
            id: id,
        }
    });
};

export const deleteQrt = (id) => {
    return axios.delete(DELETE_QRT, {
        params: {
            id: id,
        }
    });
};

export const updateQst = (id,data) => {
    return axios.put(UPDATE_QST, data,{
        params: {
            id: id,
        }
    });
};

export const updateQrt = (id,data) => {
    return axios.put(UPDATE_QRT,data, {
        params: {
            id: id,
        }
    });
};


